import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return {
		overviewFlex: {
			display         : "flex",
			flexDirection   : "column",
			marginBottom    : theme.other.isMobile ? "1rem" : "0",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.secondaryBlack : theme.other.paletteNew.secondaryBackgroundGrey,
			gap             : "1rem"
		},
		overviewRoot: {
			height          : "calc(100vh - 65px)",
			display         : "flex",
			flexDirection   : "column",
			width           : "100%",
			gap             : "2rem",
			padding         : theme.other.isMobile ? "0rem" : "2rem",
			overflow        : "auto",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.secondaryBlack : theme.other.paletteNew.secondaryBackgroundGrey
		},
		heading: {
			fontSize   : "2rem",
			fontWeight : "500",
			padding    : theme.other.isMobile ? "2rem 2rem 0 2rem" : 0
		},
		overviewGrid: {
			display             : "grid",
			gridTemplateColumns : "2.5fr 1fr",
			// gridTemplateRows    : "1fr 1fr 1fr",
			gap                 : "2rem"
		},
		channelAnalytics: {
			gridArea     : "1 / 1 / 2 / 2",
			borderRadius : theme.other.isMobile ? "0" : "2rem"
		},
		earning: {
			gridArea     : "1 / 2 / 3 / 3",
			borderRadius : theme.other.isMobile ? "0" : "2rem"
		},
		content: {
			gridArea     : "2 / 1 / 4 / 2",
			borderRadius : theme.other.isMobile ? "0" : "2rem",
			height       : "auto"
		},
		faq: {
			gridArea     : "3 / 2 / 4 / 3",
			borderRadius : theme.other.isMobile ? "0" : "2rem"
		},
		latestContentWrapper: {
			display       : "flex",
			flexDirection : "column",
			width         : "100%",
			padding       : "2rem",
			gap           : "2rem"
		},
		title: {
			fontWeight : "500",
			fontSize   : "1.6rem"
		}
	};
} );
